const routes = {
  home: '/',
  movies: '/movies',
  movieDetails: '/movies/:movieId',
  movieCast: '/movies/:movieId/cast',
  movieReviews: '/movies/:movieId/reviews ',
};

export default routes;
